import { JSONTables, OutputLocation } from '../../types';

const PRODUCT_DATA_BASE_URL = '/product-data';

const productDataFetch = async (fileName: string) =>
	(await fetch(`${PRODUCT_DATA_BASE_URL}/${fileName}`)).json();

export const fetchProductData = async (): Promise<JSONTables> => {
	const tableNames = (await productDataFetch(
		'tableNames.json'
	)) as OutputLocation[];

	const output: Partial<JSONTables> = {};
	const tablePromises: Promise<void>[] = [];

	for (let i = 0; i < tableNames.length; ++i) {
		const { tableName: name, fileName } = tableNames[i];

		tablePromises.push(
			productDataFetch(fileName)
				.then(tableJson => {
					output[name] = tableJson;
				})
				.catch(err => {
					throw err;
				})
		);
	}

	await Promise.all(tablePromises);

	return output as JSONTables;
};
